import { BrowserRouter, RouterProvider } from "react-router-dom";
import { ROUTER } from "../../Router";
import { useAuthorization } from "Common/Hooks";
import { AppLoading } from "Common/Components";
import { AccessDenied } from "./Containers/AccessDenied";

export const AuthLayout = () => {
  const { authorizationsResponse, isLoadingAuthorizations, isErrorAuthorizations, isSuccessAuthorizations } =
    useAuthorization();

  if (isErrorAuthorizations) {
    return (
      <BrowserRouter>
        <AccessDenied title={"Unauthorized"} description="Please contact admin." />
      </BrowserRouter>
    );
  } else if (isLoadingAuthorizations || !authorizationsResponse) {
    return <AppLoading />;
  } else if (!isLoadingAuthorizations && isSuccessAuthorizations) {
    return <RouterProvider router={ROUTER} />;
  }
};
